import React, { useEffect, useState } from 'react'
import { Typography, Button } from 'antd'

//import Background from "../../../Assets/background.avif"
import Background from "../../../Assets/backgroundLucha.jpeg"
import PKcloseImg from "../../../Assets/pokeball_close.png"
import PKopenImg from "../../../Assets/pokeball_open.png"

import Confetti from 'react-confetti'

import {
    Container,
    PokeBallClose,
    PokeBallOpen,
    CardLoot,
    ButtonContainer,
    BlinkDiv
} from "./styles"
import {  useLocation, useNavigate } from "react-router-dom";
const { Title } = Typography;

export const Cupones = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false)
    const location = useLocation();
  
    const objetos = location.state || [
        {
            "id": 2,
            "nombre": "Piedra fuego",
            "descripcion": "Sirve para evolucionar pokemons",
            "tier": 1,
            "imagen": "https://images.wikidexcdn.net/mwuploads/wikidex/0/08/latest/20070904205723/Piedra_fuego.png",
           
        }
    ];

    // abre pokeboll
    setTimeout(() => {
            setOpen(true)
        }, 5000);

    return (
        <Container background={Background}>
            {
                open && 
                <div style={{
                    height: "60vh",
                    overflowY: "scroll",
                    zIndex:3,
                }}>
                <div style={{
                    marginTop: objetos.length > 2 ? "2rem" : "8rem",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "16px",
                    padding: "16px",
                    justifyContent: "center",
                    
                  }}>
                    {
                        
                        objetos.map(item => (
                            <div 
                              key={item.id}
                              style={{
                                position: "relative", 
                                textAlign: "center",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                padding: "10px",
                                backgroundColor: "#f9f9f9",
                                width: "120px",
                              }}
                            >
                              {item.cantidad && (
                                <div style={{
                                  position: "absolute",
                                  top: "-8px",
                                  right: "-8px",
                                  backgroundColor: "#ff4d4f",
                                  color: "white",
                                  borderRadius: "50%",
                                  width: "24px",
                                  height: "24px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  boxShadow: "0 0 4px rgba(0,0,0,0.3)",
                                }}>
                                  {item.cantidad}
                                </div>
                              )}
                              
                              <img
                                src={item.imagen}
                                alt={item.nombre}
                                style={{
                                  width: "70px",
                                  height: "70px",
                                  objectFit: "contain",
                                }}
                              />
                              <Title level={4} style={{ marginTop: "10px", fontSize: "14px" }}>
                                {item.nombre}
                              </Title>
                            </div>
                          ))
                    }
                   
                </div></div>
            }
            {
                !open 
                ? <PokeBallClose src={PKcloseImg} /> 
                : <PokeBallOpen src={PKopenImg} /> 
            }
            {
                open && <BlinkDiv />
            }
            {
                open && 
                <Confetti
                  style={{ position: "absolute", zIndex: 12, width: "100vw", height: "100vh"}}
            
                  numberOfPieces={400}
                  recycle={false}
                />
            }
            {
                open && 
                <ButtonContainer>
                    <Button type="primary" onClick={() => navigate('/configuracion')}shape="round" size={"large"} style={{backgroundColor: "rgb(8, 179, 102)"}}>
                        Aceptar
                    </Button>
                </ButtonContainer>
            }
        </Container>
    )
}
